import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reboot-dialog',
  templateUrl: './reboot-dialog.component.html',
  styleUrls: ['./reboot-dialog.component.css'],
})
export class RebootDialogComponent implements OnInit {
  public breakpoint: number; // Breakpoint observer code

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public dialogRef: MatDialogRef<RebootDialogComponent>
  ) {}

  public ngOnInit(): void {
    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  confirmReboot() {
    this.dialogRef.close({ event: 'Reboot' });
  }

  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }
}
